import { CanvasTexture, Mesh, MeshBasicMaterial, PlaneGeometry } from 'three';

export const buildLabelMesh = (
  text: string,
  fg: string,
  bg: string,
  width = 0.92,
): Mesh => {
  const w = 512;
  const h = 256;
  const c = document.createElement('canvas');
  c.width = w;
  c.height = h;
  const ctx = c.getContext('2d');
  if (ctx) {
    ctx.clearRect(0, 0, w, h);
    const r = 70;
    ctx.fillStyle = bg;
    ctx.beginPath();
    ctx.moveTo(r, 0);
    ctx.arcTo(w, 0, w, h, r);
    ctx.arcTo(w, h, 0, h, r);
    ctx.arcTo(0, h, 0, 0, r);
    ctx.arcTo(0, 0, w, 0, r);
    ctx.closePath();
    ctx.fill();

    ctx.strokeStyle = 'rgba(0,0,0,0.18)';
    ctx.lineWidth = 6;
    ctx.stroke();

    ctx.fillStyle = fg;
    ctx.font = `900 ${h * 0.55}px -apple-system, "Helvetica Neue", Arial, sans-serif`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(text, w / 2, h / 2 + 8);
  }
  const tex = new CanvasTexture(c);
  tex.anisotropy = 8;
  const aspect = w / h;
  const geo = new PlaneGeometry(width, width / aspect);
  const mat = new MeshBasicMaterial({
    map: tex,
    transparent: true,
    depthTest: true,
    depthWrite: false,
  });
  const mesh = new Mesh(geo, mat);
  mesh.position.z = 0.45;
  mesh.renderOrder = 4;
  return mesh;
};
